import React from 'react'
import { Box, CardMedia, GridList, Typography } from '@material-ui/core'
import { RoutePath } from 'constants/RoutePath'
import ButtonLink from 'components/shared/ButtonLink'
import SuccessImage1 from 'pages/Onboarding/images/success-1.png'
import SuccessImage2 from 'pages/Onboarding/images/success-2.png'
import SuccessImage3 from 'pages/Onboarding/images/success-3.png'

const SuccessDescription: React.FC<{ organizationName: string }> = ({ organizationName }) => {
  return (
    <>
      <Box mt={4} mb={2} display='flex' justifyContent='center'>
        <ButtonLink text={`Explore ${organizationName}`} to={RoutePath.Home} />
      </Box>

      <GridList cols={3} spacing={4} style={{ width: '100%' }} cellHeight='auto'>
        <CardMedia component='img' src={SuccessImage1} />
        <CardMedia component='img' src={SuccessImage2} />
        <CardMedia component='img' src={SuccessImage3} />
      </GridList>

      <Box mt={2}>
        Need help?{' '}
        Reach out to the {organizationName} concierge team to further assist you in getting started.
      </Box>
    </>
  )
}

export default SuccessDescription
